import { ExtranetTab, ExtranetTabs, useBreakpoint, useLanguage } from '@pharmac-extranet/shared'
import { PharmacH3, PharmacRow } from '@pharmac/ui'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { CustomerInfo } from '../../components/customer/CustomerInfo'
import { CustomerInfoMobile } from '../../components/customer/CustomerMobileInfo'
import { ExtranetWrapper } from '../../components/extranet/ExtranetWrapper'
import { AuthorizedRoot, useIsAuthorized } from '../../router/RouteGuards'
import { useExtranetPath } from '../../router/useExtranetPath'
import { CustomerUsersView } from './CustomerUsersView'

export type CustomerViewProps = {
  activePage?: 'info' | 'users'
}

export const CustomerView = (props: CustomerViewProps) => {
  const { t } = useLanguage(['extranet', 'common'])
  const { minDesktop, maxTablet } = useBreakpoint()

  const navigate = useNavigate()

  const [initialTabIndex, setInitialTabIndex] = useState<number>()

  const createPath = useExtranetPath()

  const hasCustomerUserManagement = useIsAuthorized({ customerUserManagement: true })

  useEffect(() => {
    const isUsersPage = props.activePage && props.activePage === 'users'
    setInitialTabIndex(isUsersPage && hasCustomerUserManagement ? 1 : 0)
  }, [props.activePage])

  return (
    <ExtranetWrapper>
      <PharmacRow>
        <PharmacH3
          color="purple"
          marginMediumTop
          marginLargeBottom
          marginMediumHorizontal={!maxTablet}
          marginMediumLeft={maxTablet}
        >
          {t('customer.title')}
        </PharmacH3>
      </PharmacRow>
      {typeof initialTabIndex === 'number' && (
        <ExtranetTabs
          childrenAreAlwaysRendered
          selectedIndex={initialTabIndex}
          singleTab={!hasCustomerUserManagement}
          tabs={[
            {
              index: 0,
              handle: t('customer.customerInfo'),
              element: (
                <ExtranetTab>{minDesktop ? <CustomerInfo /> : <CustomerInfoMobile />}</ExtranetTab>
              ),
              onClick: () => navigate(createPath('oma-annos.customership')),
            },
            {
              index: 1,
              handle: t('customer.customerUserList'),
              onClick: () => navigate(createPath('oma-annos.customership.users')),
              element: (
                <AuthorizedRoot customerUserManagement>
                  <ExtranetTab>
                    <CustomerUsersView />
                  </ExtranetTab>
                </AuthorizedRoot>
              ),
            },
          ].filter((tab) => tab.index !== 1 || (tab.index === 1 && hasCustomerUserManagement))}
        />
      )}
    </ExtranetWrapper>
  )
}
